enum Roles {
  Admin = 'admin',
  AccountManager = 'accountManager',
  Camper = 'camper',
  OrderManager = 'orderManager'
};

export default Roles;
